export default __webpack_public_path__ + "static/media/Bookmarked-Topic.6d70dd13.svg";